import { IAccountMappingTemplateGroupItemFLI } from '@modeso/types__aumico-lib-annualreport-be';

export interface ICashFlowTotalComponentInput {
    currentTotal: number;
    previousTotal: number;
    cashAndCashEquivalentsFli: IAccountMappingTemplateGroupItemFLI;
    openingCashAndCashEquivalents: number | null;
    closingCashAndCashEquivalents: number | null;
    previousOpeningCashAndCashEquivalents: number | null;
    previousClosingCashAndCashEquivalents: number | null;
}
